module.exports = __webpack_public_path__ + "media/images/drag-handle-17e485fbefa8a1e439e68d6c57b3d971.svg";